import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
// import Home from "../pages/client/Home";
// import Footer from "../components/client/Footer";
import "../styles/client.css";
// import Header from "../components/client/Header";
import ForgotPage from "../components/common/ForgotPage";
import Registration from "../components/auth/Registration";
import VendorLogin from "../components/auth/VendorLogin";
import VendorRegistration from "../components/auth/VendorRegistration";
import SignIn from "../components/auth/SignIn";
import AdminLogin from "../components/auth/AdminLogin";
import Wellcomepage from "../components/auth/Register/AddRegister/Wellcomepage";
import Register from "../components/auth/Register/AddRegister/Register";
import ScrollToTop from "../pages/ScrollToTop";
import ResetPage from "../components/common/ResetPage";
import ForgotSuccess from "../components/common/ForgotSuccess";
// import NotFound from "../components/common/NotFound";
import EmailVerifySuccess from "../components/client/EmailVerifySuccess";

function Client({
  handleLogout,
  handleLogin,
  handleVendorLogin,
  handleClientLogin,
  handleAffiliateLogin,
  isClientLogin,
}) {
  return (
    <div>
      <div style={{ background: "" }}>
        <BrowserRouter basename="/dealsmachiVendor">
          {/* <Header /> */}
          <ScrollToTop />
          <Routes>
            {/* <Route path="/" element={<Home  />} /> */}
            {/* <Route path="*" element={<NotFound />} /> */}
            {/* <Route path="/" element={<Registration />} /> */}
            {/* <Route path="/vendorregistration" element={<VendorRegistration />} /> */}
            <Route
              path="/"
              element={
                <VendorLogin
                  handleVendorLogin={handleVendorLogin}
                  handleLogin={handleLogin}
                  handleAffiliateLogin={handleAffiliateLogin}
                />
              }
            />
            <Route
              path="*"
              element={
                <VendorLogin
                  handleVendorLogin={handleVendorLogin}
                  handleLogin={handleLogin}
                  handleAffiliateLogin={handleAffiliateLogin}
                />
              }
            />
            <Route path="/wellcomepage/:id" element={<Wellcomepage />} />
            <Route path="/forgotsuccess" element={<ForgotSuccess />} />
            <Route
              path="/register"
              element={<Register handleVendorLogin={handleVendorLogin} />}
            />
            <Route
              path="/vendorregistration/:id"
              element={
                <VendorRegistration handleVendorLogin={handleVendorLogin} />
              }
            />
            <Route path="/forgot" element={<ForgotPage />} />
            <Route path="/resetpassword" element={<ResetPage />} />
            <Route
              path="/emailverifysuccess"
              element={<EmailVerifySuccess />}
            />
          </Routes>
          {/* <Footer /> */}
        </BrowserRouter>
      </div>
    </div>
  );
}

export default Client;
